import { type CgrPayload } from '#app/services/ai/types.ts'
import { type LegalSourceCitationBehavior } from '#app/services/legal-ai/shared/source-contract.ts'
import { capitalizeAllWords } from '#app/utils/text.js'

type CgrCitationPayload = Omit<CgrPayload, 'content'> & { id: string | number }

// TODO: Replace with real URL generation once available
export function getCgrDocumentUrl(documentId: string): string {
	return `/enlace/cgr/${documentId}`
}

export const cgrDocumentAsTitle = (cgrPayload: CgrCitationPayload) => {
	return capitalizeAllWords(cgrPayload.title, true)
}

export function normalizeCgrCitationLeadIn(leadIn: string, payload: CgrCitationPayload) {
	const canonicalNumber = String(payload.document_number ?? '').trim()
	if (!canonicalNumber) return leadIn
	return leadIn.replace(
		/(\b(?:oficio|dictamen|documento)\s+(?:n(?:[°ºo]|\.?)\s*)?)(\*\*)?[A-Z0-9]+(?:[-/][A-Z0-9]+){1,6}(\*\*)?(?![\s\S]*\b(?:oficio|dictamen|documento)\b)/i,
		(_match, prefix: string, openingBold = '', closingBold = '') =>
			`${prefix}${openingBold}${canonicalNumber}${closingBold}`,
	)
}

export const costaRicaCgrCitation: LegalSourceCitationBehavior<CgrPayload> = {
	title: cgrDocumentAsTitle,
	url: payload => getCgrDocumentUrl(payload.idDocument),
	inlineTagName: 'cgrdocument',
	modelAlias: { prefix: 'CGR' },
	normalizeCitationLeadIn: normalizeCgrCitationLeadIn,
	legacyTagNames: ['CgrDocument', 'cgr-document'],
	fallbackUrl: getCgrDocumentUrl,
	iconName: 'book',
	linkClassName: 'text-green-600',
	inlineSecondaryText: payload => payload.document_type,
	summaryLabel: 'documentos CGR',
	summaryIconName: 'file-text',
	summaryIconClassName: 'text-green-500',
	summaryDotClassName: 'bg-green-500',
	summaryTitle: payload => `${payload.document_type}-${payload.document_number}`,
}
